import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LinkIcon from "@mui/icons-material/Link";
import KeyIcon from "@mui/icons-material/Key";
import {
  GenerateCredentialsButton,
  AllocateButton,
} from "../../../../Global_Component/GlobalButtonComponent";
import { SearchBar } from "../../../../Global_Component/CustomInputComponent";
import OnBoardClientToDashboard from "../../../../Global_Component/generateCredentialbyCrm";
import environment from "../../../../enviroment";
import axios from "axios";
const rows = [
  {
    id: 1,
    name: "Atif Khan",
    mobile: "+91-9897765443",
    inquiry: "Halal certificate",
  },
  {
    id: 2,
    name: "Talan Curtis",
    mobile: "+1 (555) 432-1098",
    inquiry: "Medical tourism assistance",
  },
  {
    id: 3,
    name: "Kadin Geidt",
    mobile: "+1 (555) 789-0123",
    inquiry: "Halal certificate",
  },
  {
    id: 4,
    name: "Ahmed Khan",
    mobile: "+1 (555) 456-7890",
    inquiry: "Halal certificate",
  },
  {
    id: 5,
    name: "Jakob Bergson",
    mobile: "+1 (555) 876-5432",
    inquiry: "Medical tourism assistance",
  },
];
const Result = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [generate, setGenerate] = useState(false);
  const [resultData, setResultData] = useState([]);
  const [data, setData] = useState({});
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const fetchLeads = async () => {
    const response = await axios.get(`${environment.endPoint}/lead/getAll`);
    setResultData(response.data.result.data);
  };

  useEffect(() => {
    // const response =await axios.get(`${environment.endPoint}/api/v1/website/lead/getAll`)
    fetchLeads();
  }, []);

  // const handleGenerateCredentails = (data) => {
  //   setData(data);
  //   setGenerate(true);
  // };

  useEffect(() => {
    console.log("current state", data);
  }, [data]);

  return (
    <>
      <OnBoardClientToDashboard
        open={generate}
        handleClose={(e) => setGenerate(false)}
        name={data.name}
        email={data.email}
        _id={data._id}
        phoneNumber={data.phoneNumber}
        
      />
      <Grid
        container
        spacing={0}
        sx={{
          display: "flex",
          my: 1,
          mx: 1,
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Grid sm={3}>
          <Typography variant="h6" color="initial">
            LEADS
          </Typography>
        </Grid>

        <Grid sm={3} sx={{ mx: 3 }}>
          <SearchBar placeholder="Search the Lead" />
        </Grid>
      </Grid>
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: 2,
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Table>
          {/* Table Header */}
          <TableHead sx={{ bgcolor: "#F6F8FA", color: "red" }}>
            <TableRow>
              <TableCell
                sx={{ fontWeight: 500, color: "#616161", textAlign: "center" }}
              >
                #
              </TableCell>
              <TableCell sx={{ fontWeight: 500, color: "#616161" }}>
                Name
              </TableCell>
              <TableCell sx={{ fontWeight: 500, color: "#616161" }}>
                Mobile Number
              </TableCell>
              <TableCell sx={{ fontWeight: 500, color: "#616161" }}>
                Inquired for
              </TableCell>
              <TableCell
                sx={{ fontWeight: 500, color: "#616161", textAlign: "right" }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>

          {/* Table Body */}
          <TableBody>
            {resultData?.map((row, index) => (
              <TableRow key={row.id}>
                {/* ID */}
                <TableCell>{index + 1}</TableCell>

                {/* Name with Avatar */}
                <TableCell
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <Avatar
                    sx={{
                      bgcolor: index % 2 === 0 ? "#FFEBEE" : "#E3F2FD",
                      color: index % 2 === 0 ? "#D32F2F" : "#1976D2",
                      fontWeight: 500,
                      width: 40,
                      height: 40,
                      fontSize: 14,
                    }}
                  >
                    {row.name
                      ?.split(" ")
                      ?.map((n) => n[0])
                      ?.join("")
                      ?.toUpperCase()}
                  </Avatar>
                  <span style={{ marginLeft: 10, fontWeight: 500 }}>
                    {row.name}
                  </span>
                </TableCell>

                {/* Mobile Number */}
                <TableCell sx={{ color: "#374151" }}>
                  {row.phoneNumber}
                </TableCell>

                {/* Inquiry */}
                <TableCell sx={{ color: "#374151" }}>
                  {row.enquiryFor}
                </TableCell>

                {/* Actions */}
                <TableCell sx={{ p: 0 }}>
                  <AllocateButton />
                  <GenerateCredentialsButton  data={row} />
                  <IconButton onClick={handleMenuOpen}>
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                  >
                    <MenuItem onClick={handleMenuClose}>Action 1</MenuItem>
                    <MenuItem onClick={handleMenuClose}>Action 2</MenuItem>
                  </Menu>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default Result;
